import { Link } from 'react-router';
import { buttonClassName } from '@ircf/ui';
import { primaryNav, publicRoutes } from '@ircf/config';
import { useSeo } from '../lib/seo.js';

/**
 * 404. Offers the primary navigation rather than a dead end, because a mistyped
 * or stale URL is usually one character away from a real page.
 */
export function NotFoundPage() {
  useSeo({
    title: 'Page not found',
    description: 'The page you requested could not be found.',
    path: '/404',
    noIndex: true,
  });

  return (
    <div className="mx-auto flex min-h-[70vh] max-w-3xl flex-col justify-center gap-8 px-4 pt-28 pb-24 sm:px-6 sm:pt-36">
      <div className="space-y-4">
        <p className="text-xs font-semibold tracking-[0.28em] text-cool-steel uppercase">
          Error 404
        </p>
        <h1 className="text-4xl font-semibold text-warm-white sm:text-5xl">Page not found</h1>
        <p className="max-w-xl text-base leading-relaxed text-platinum">
          That address does not match any page on this site. It may have moved, or the link may have
          been mistyped.
        </p>
      </div>

      <div className="flex flex-wrap gap-3">
        <Link to="/" className={buttonClassName({ variant: 'primary' })}>
          Return to the homepage
        </Link>
        <Link
          to={publicRoutes.book.path}
          className={buttonClassName({ variant: 'secondary' })}
        >
          Book a consultation
        </Link>
      </div>

      <nav aria-label="Site sections" className="border-t border-white/10 pt-8">
        <h2 className="text-sm font-medium text-warm-white">Or try one of these</h2>
        <ul className="mt-4 grid gap-2 sm:grid-cols-2">
          {primaryNav
            .filter((route) => route.path !== '/' && route.id !== publicRoutes.login.id)
            .map((route) => (
              <li key={route.id}>
                <Link
                  to={route.path}
                  className="text-sm text-platinum underline decoration-white/25 underline-offset-4 hover:text-warm-white"
                >
                  {route.label}
                </Link>
              </li>
            ))}
        </ul>
      </nav>
    </div>
  );
}

export default NotFoundPage;
